const localImgLoad = (location) => require(`../assets/${location}`);
export default localImgLoad